import { Component, ViewChild } from "@angular/core";
import {
  NavController,
  ModalController,
  Refresher,
  App,
  Content,
  AlertController,
} from "ionic-angular";
import { EntityPage } from "../entity/entity";
import { BehaviorSubject, Subscription } from "rxjs";
import { TimeParams } from "../../models/TimeParams";
import { Customer } from "../../app/models/Customer";
import { EntitiesProvider } from "../../providers/entities/entities";
import { Train } from "../../app/models/Train";
import { DemoProvider } from "../../providers/demo/demo";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";
import { TemplateProvider } from "../../providers/template/template";
@Component({
  selector: "page-customer-overview",
  templateUrl: "customer-overview.html",
})
export class CustomerOverviewPage {
  customer: Customer;
  refresher: Refresher;
  refreshEvent = new BehaviorSubject<TimeParams>(null);
  timeParams: any;
  visibility: any;
  trainStatsSubscriptions: Subscription[] = [];
  id;
  visibilities = new Map<number, boolean>();
  @ViewChild(Content) content: Content;
  showTimeSelector: boolean;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    private app: App,
    private entitiesProvider: EntitiesProvider,
    private demo: DemoProvider,
    private alertCtrl: AlertController,
    private starms: StarmsClientProvider,
    private templateProvider: TemplateProvider
  ) {}

  ionViewDidLoad() {
    this.customer = this.entitiesProvider.currentEntity as Customer;
    if (!this.demo.demoMode) {
      this.entitiesProvider.getTrainStatus(this.customer.getId());
    }

    this.getTemplate();
  }

  async presentAlert(element: any) {
    let alert = this.alertCtrl.create({
      title: element.title,
      message: element.message,
      buttons: [
        {
          text: "Do not show again",
          role: "cancel",
          handler: () => {
            this.visibilities[element.id] = false;
            localStorage.setItem(
              "visibilities",
              JSON.stringify(this.visibilities)
            );
          },
        },
        {
          text: "Dismiss",
          role: "dismiss",
          handler: () => {},
        },
      ],
    });
    await alert.present();
  }

  goToTrain(train: Train) {
    this.entitiesProvider.currentEntity = train;
    this.app.getRootNav().push(EntityPage);
  }

  refresh(refresher: Refresher) {
    this.refreshEvent.next(this.timeParams);
    refresher.complete();
  }

  changeTime(params: TimeParams) {
    this.timeParams = params;
    this.refreshEvent.next(params);
  }

  getTemplate(): void {
    this.showTimeSelector = this.templateProvider.hasKPIs;
  }
}



// WEBPACK FOOTER //
// ./src/pages/customer-overview/customer-overview.ts